module.exports = __webpack_public_path__ + "img/Weapon_118.1c14117a.png";